//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteHostingType } from './Enums';

export class VerifyUrlInputItem extends ItemBase {
    Url: string | null = null;
    HostingType: WebsiteHostingType = WebsiteHostingType.ExternallyHosted;

    constructor(initializer?: Partial<VerifyUrlInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "VerifyUrlInputItem";
}
